import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pushApi } from '../api/push-api';
import { subscribe, toDeviceBody } from '../lib/push-browser';

import { pushKeys } from './push-keys';

/** Asks for permission, subscribes this browser and registers it; the card shows a refusal. */
export function useEnablePush(publicKey: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => pushApi.register(toDeviceBody(await subscribe(publicKey))),
    meta: { successMessage: 'push:toasts.enabled', silentError: true },
    onSuccess: (device) => {
      queryClient.setQueryData(pushKeys.thisDevice(publicKey), device);
      void queryClient.invalidateQueries({ queryKey: pushKeys.settings() });
    },
  });
}
